import React, { FC } from 'react';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Anime from 'animejs';
import { IReadableNotification } from '../../../../state/notifications';
import { NotificationType } from '../../../../api/vault/notifications';
import { Styling, Colors, Animations } from '../../../../constants';

interface IProps {
  notification: IReadableNotification;
  markRead: () => void;
}

interface IStyleProps {
  type: number;
}

const getNotifTheme = (type: number): string => {
  switch (type) {
    case NotificationType.Info:
      return `
        color: ${Colors.WHITE_100};
        background-color: ${Colors.INFO};
        border-bottom: 3px solid ${Colors.INFO_BORDER};
      `;
    case NotificationType.Alert:
      return `
        color: ${Colors.WHITE_100};
        background-color: ${Colors.WARNING};
        border-bottom: 3px solid ${Colors.WARNING_BORDER};
      `;
    case NotificationType.Error:
      return `
        color: ${Colors.WHITE_100};
        background-color: ${Colors.ERROR};
        border-bottom: 3px solid ${Colors.ERROR_BORDER};
      `;
    default:
      return null;
  }
};

const NotificationContainer = styled.div<IStyleProps>`
  display: flex;
  padding: ${Styling.DEFAULT_SPACING}px;
  box-shadow: 0 2px;
  font-weight: bolder;
  text-align: center;
  ${(props) => getNotifTheme(props.type)}
  h1 {
    cursor: default;
    margin-left: auto;
    margin-right: auto;
    margin-top: ${Styling.DEFAULT_SPACING}px;
    a {
      color: inherit
    }
  }
`;

const CloseButton = styled(IconButton)`
  color: ${Colors.WHITE_100} !important;
`;

const Notification: FC<IProps> = (props: IProps) => {
  const { notification, markRead } = props;
  const notificationRef: React.RefObject<HTMLDivElement> = React.createRef();
  const onMarkRead = (e: React.MouseEvent) => {
    const { current: container } = notificationRef;
    Anime({
      targets: container,
      loop: false,
      ...Animations.ANIME_FADE_OUT,
      complete: () => {
        markRead();
        // note: due to strange animation loop bug, need to reset opacity for next target
        Anime({
          targets: container,
          loop: false,
          ...Animations.ANIME_FADE_IN,
        });
      },
    });
  };
  return (
    <NotificationContainer
      type={notification.type}
      ref={notificationRef}
    >
      <h1 dangerouslySetInnerHTML={{ __html: notification.message }} />
      <CloseButton
        onClick={onMarkRead}
      >
        <CloseIcon />
      </CloseButton>
    </NotificationContainer>
  );
};

export default Notification;
